<template>
  <v-menu>
    <template #activator="{ props }">
      <v-avatar v-bind="props" size="45" color="primary" class="font-weight-medium pb-1" rounded="lg">
        {{ userInitials }}
      </v-avatar>
    </template>
    <v-list class="pa-0">
      <v-list-item class="bg-primary pa-4">
        <v-list-item-title class="user-block__name font-weight-bold">
          {{ user?.firstName }} {{ user?.lastName }}
        </v-list-item-title>
        <v-list-item-subtitle class="user-block__email"
          >{{ user?.emailAddress }}
        </v-list-item-subtitle>
      </v-list-item>
      <v-list-item class="user-block__logout" @click="logoutModel = true">
        <template #prepend>
          <v-icon color="red-accent-4">mdi-logout</v-icon>
        </template>
        <v-list-item-title>Logout</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <app-dialog
    v-model="logoutModel"
    title="Confirm"
    text="Are you sure you want to logout?"
    :width="400"
    @cancel="logoutModel = false"
    @confirm="logout"
  ></app-dialog>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'

import AppDialog from './AppDialog.vue'

import { useAppStore } from '@/stores/app'
import AppService from '@/services/appService'

const appStore = useAppStore()

const user = ref(appStore.user)
const logoutModel = ref(false)

const userInitials = computed(() => {
  if (user.value) {
    return user.value.firstName.charAt(0) + user.value.lastName.charAt(0)
  }
  return null
})

const logout = () => {
  appStore.setUser(null)
  appStore.setSelectedBusinessProfileId(null)
  logoutModel.value = false
  const appService = new AppService()
  appService.clearAuthData()
}
</script>
